export const markAllAsRead = "kbb";
export const markAsReadNumberOfConversationsWhenCountIsNegative = "lbb";
export const markAsReadNumberOfItemsWhenCountIsNegative = "mbb";
export const markAsReadNumberOfConversations = "nbb";
export const markAsReadNumberOfItems = "obb";
export default {markAllAsRead,markAsReadNumberOfConversationsWhenCountIsNegative,markAsReadNumberOfItemsWhenCountIsNegative,markAsReadNumberOfConversations,markAsReadNumberOfItems};